import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {RouterPaths} from "../../config/router.paths.model";
import {slideToLeft} from "../../animations/router.animations";
import {PopupComponent} from "../../shared/popup/popup.component";
import {LoaderService} from "../../service/loader.service";
import {SupportService} from "../../service/support/support.service";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-support',
    templateUrl: './support.component.html',
    styleUrls: ['./support.component.scss'],
    animations: [slideToLeft],
    host: {'[@slideToLeft]': ''}
})
export class SupportComponent implements OnInit {
    frameUrl;
    constructor(private loaderService: LoaderService,
                private route: ActivatedRoute,
                private router: Router,
                public sanitizer: DomSanitizer,
                private supportService: SupportService,
                private popupComponent: PopupComponent,) {

    }

    ngOnInit() {
        this.getChatLink();
    }

    getChatLink() {
        this.supportService.getSession().subscribe(data => {
            this.getChatLinkResult(data);
        }, (error) => {
            this.loaderService.hideAndShowTryAgain();
        }, () => {
            this.loaderService.hide();
        });
    }

    getChatLinkResult(data) {
        try {
            if (data.status) {
                this.frameUrl = this.getLink(data.sessionLink);
            } else if (data.status === false) {
                this.popupComponent.showPopupError({text: data.message});
            } else {
                this.loaderService.hideAndShowTryAgain();
            }
        } catch (e) {
            this.loaderService.hideAndShowTryAgain();
        }

    }

    getBackLink() {
        return RouterPaths.rewards.main;
    }

    getLink(url){
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }
}
